
const url = window.location.href;
const variant = url.split("products/")[1];
const prod_handle = variant.split("?")[0];

var cartContents = fetch("http://crowdfunding.notimidsouls.com/api/getReviewsByProductHandle",{
    method: "post",
    // mode: "no-cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
            'Content-type': 'application/json; charset=UTF-8'
        },
    body: JSON.stringify({
      "product_id" : prod_handle
    }),
})
  .then(response => response.json())
  .then(data => {
    response = data.message;
    if(response.length){
      
    var dummyHtml = '<div class="rl-main-card"><h3>Reviews</h3><hr class="rl-lc-hr">';
    for (let i = 0; i < response.length; i++) {
        let item = response[i];
      
      var rating = item.ratings;
      
       var mainRate = '<div class="rating">';
        mainRate += '<span class="fa fa-star ';
        if(rating >= 1 ) mainRate += ' checked ';
        mainRate += '"></span>';
        
        mainRate += '<span class="fa fa-star ';
        if(rating >= 2 ) mainRate += ' checked ';
        mainRate += '"></span>';
        
        mainRate += '<span class="fa fa-star ';
        if(rating >= 3 ) mainRate += ' checked ';
        mainRate += '"></span>';
        
        mainRate += '<span class="fa fa-star ';
        if(rating >= 4 ) mainRate += ' checked ';
        mainRate += '"></span>';
        
        mainRate += '<span class="fa fa-star ';
        if(rating >= 5 )mainRate += ' checked ';
        mainRate += '"></span></div>';
      
        let verified_buyer = '';
        if(item.is_varified_buyer == '1'){
          verified_buyer = "Verified Buyer"
        }
      
        let productName = (item.product_name).toUpperCase();
        dummyHtml += '<div class="rl-loop-content"><span class="rl-item-title">'+item.reviewer_name+'&nbsp;</span><span class="rl-item-verified_buyer">Verified Buyer</span><br>'+mainRate+'<br><span class="rl-item-comment">'+item.review_comment+'</span><br><hr class="rl-lc-hr"></div>';
    }
    dummyHtml += '</div>';
    document.getElementById("review-list-main").innerHTML = dummyHtml;
    }
  })
  .catch(err => console.log("ERR->",err));